import React, { useEffect, useState, useMemo } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "../src/assests/css/styles.css";

import { LoginRoutes } from "./routes/LoginRoutes";
import { PublicRoutes } from "./routes/PublicRoutes";
import useAxiosFile from "./actions/useaxios";
import { DecryptData, EncryptData, isEmpty } from "./actions/common";
import { getToken } from "firebase/messaging";
import { messaging } from "./actions/firebase";
import NotFound from "./pages/NotFound";
function App() {

  const [fcm, setfcm] = useState('')
  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "AIzaSyCHTjyQKgvjbZU7mo_YdE9B7FJMDgrNLOs",
      });

      //We can send token to server

      setfcm(token)
    } else if (permission === "denied") {
      //notifications are blocked
      alert("You denied for the notification");
    }
  }

  useEffect(() => {
    // requestPermission();
  }, []);
  const usertoken = ("; " + document.cookie)
    .split(`; token_a=`)
    .pop()
    .split(";")[0]
    ? ("; " + document.cookie).split(`; token_a=`).pop().split(";")[0]
    : "";

  console.log('usertokenusertoken', usertoken)

  const { admin_panel, payload, token } = useSelector(
    (state) => state.admin_panel.User
  );
  const dispatch = useDispatch();

  const axiosfile = useAxiosFile();

  const _id_a = localStorage.getItem("_id_a"),
    userAuth = localStorage.getItem("userAuth");
  const HavAccess = !isEmpty(_id_a)
    ? DecryptData(_id_a)
    : payload?._id
      ? payload?._id
      : DecryptData(_id_a);


  const [Auth, SetAuth] = useState(usertoken ? usertoken : false);

  console.log('authauth', Auth)
  useEffect(() => {
    SetAuth(usertoken ? usertoken : token);
    if (!isEmpty(HavAccess) && HavAccess != "undefined") {
      AlreadyExits(HavAccess);
    } else if (HavAccess == "undefined") {
      localStorage.clear();
      document.cookie =
        "token_a" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    } else {
      dispatch({
        type: "Login",
        Register_Section: { App_Inside: true },
      });
    }
  }, [token]);

  const AlreadyExits = async (HavAccess) => {

    await axiosfile.AlreadyExits({ data: EncryptData({ _id: HavAccess, fcm }) });
  };


  useEffect(() => {
    if (process.env.NODE_ENV == "production") {
      console.log = () => { };
      console.warning = () => { };
      console.info = () => { };
      console.error = () => { };
    }
  }, []);

  return useMemo(() => {
    return (
      <BrowserRouter basename="/">
        <Routes>
          <Route path="*" element={<NotFound />} />
          {/* <Route path="/404" element={<NotFound />} /> */}

          {LoginRoutes(Auth)} {PublicRoutes(Auth, token)}
        </Routes>
      </BrowserRouter>
    );
  }, [Auth, token]);
}

export default App;
